export const ACTIVE_DELETE_PROPOSAL_PROFILE = "ACTIVE_DELETE_PROPOSAL_PROFILE";
export const ACTIVE_DELETE_PROFILE = "ACTIVE_DELETE_PROFILE";
export const ACTIVE_DELETE_CERTIFICATIONS = "ACTIVE_DELETE_CERTIFICATIONS";
export const ACTIVE_DELETE_AWARDS = 'ACTIVE_DELETE_AWARDS';
export const ACTIVE_DELETE_RESET = 'ACTIVE_DELETE_RESET';

const deleteProposalImgProfile = (data) => {
    return {
        type: ACTIVE_DELETE_PROPOSAL_PROFILE, 
        data,
    };
}

const deleteImgProfile = (data) => {
    return {
        type: ACTIVE_DELETE_PROFILE, 
        data,
    };
}

const deleteImgCertifications = (data) => {
    return {
        type: ACTIVE_DELETE_CERTIFICATIONS, 
        data,
    };
}

const deleteImgAwards = (data) => {
    return {
        type: ACTIVE_DELETE_AWARDS, 
        data,
    };
}

const deleteReset = () => {
    return {
        type: ACTIVE_DELETE_RESET,
    };
}

export const activeDeleteProposalImgProfile = (boolCancel) => dispatch => {
    dispatch(deleteProposalImgProfile(boolCancel))
}

export const activeDeleteImgProfile = (boolCancel) => dispatch => {
    dispatch(deleteImgProfile(boolCancel))
}

export const activeDeleteImages = (name, index, boolCancel) => dispatch => {
    if (name.includes('Cert')) {
        dispatch(deleteImgCertifications({index, boolCancel}))
    }
    if (name.includes('Award')) {
        dispatch(deleteImgAwards({index, boolCancel}))
    }
}

export const activeDeleteReset = () => dispatch => {
    dispatch(deleteReset())
}

